const tabs = {
    "01MI": { path: "mml-opinion-search", label: "Мишљења и други акти", base: 'mml' },
    "02PI": { path: "mml-qa-search", label: "Питања и одговори", base: 'mml' },
    "03MO": { path: "mml-model-search", label: "Модели уговора и других аката", base: 'mml' },
    "04LI": { path: "mml-literature-search", label: "Литература", base: 'mml' },
    "05SU": { path: "supa-standardSearch", label: "Судска пракса", base: 'supa' },
};

export default tabs;